import React, {useState} from "react"
import { injectIntl, FormattedMessage } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import { Button } from "react-bootstrap"
import PriceListValidationEditModal from "../modal/PriceListValidationEditModal"
import priceListMessages from "../helpers/priceListMessages"
import { getPriceList } from "../../state/price-list/priceListSelectors"
import { connect, ConnectedProps } from "react-redux"
import PriceListLimitRuleDisplayComponent from "./PriceListLimitRuleDisplayComponent"
import { LIMIT_RULE_KEY } from "../../state/price-list/ruleStrategyKeys"
import Icon from "../../common/icon/icon.component"


type OwnProps = {
    priceListId: string
}
const PriceListValidatorSelectComponent = (props: Props & IntlProps) => {
    if (!props.priceList) { return <></> }
    const [isEdit, setIsEdit] = useState<boolean>(false)
    const {priceList} = props
    
    return (
        <div className="col-12 col-form-label custom-form-label bg-light pt-2 pr-2 pb-2">
            {isEdit &&
                <PriceListValidationEditModal
                    onHide={() => setIsEdit(false)}
                    priceListId={props.priceListId}
                />
            }

            <div className="row col-12 justify-content-between p-0 m-0">
                <div>
                    <FormattedMessage
                        id="price_list.edit.price_list_rules_label"
                        defaultMessage="Rules"
                    />
                </div>
                <Button onClick={() => setIsEdit(true)}>
                    <Icon value={"pencil-ruler"} className={"mr-1"} />
                    <FormattedMessage 
                        id="price_list.edit.validation_rules.edit_button_label"
                        defaultMessage="Edit"
                    />
                </Button>
            </div>

            <p className={"m-0"}>
                {props.intl.formatMessage(priceListMessages[priceList.getValidationStrategyKey()])}
            </p>

            {priceList.getValidationStrategyKey() == LIMIT_RULE_KEY &&
                <PriceListLimitRuleDisplayComponent
                    priceList={priceList}
                />
            }
        </div>
    )
}

const mapState = (state, props: OwnProps) => {
    return {
        ...props,
        priceList: getPriceList(state, props.priceListId)
    }
}
const connector = connect(mapState, {})
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(PriceListValidatorSelectComponent))


// WEBPACK FOOTER //
// ./src/price-list/components/PriceListValidatorSelectComponent.tsx